export class Versioning {

    public major: number;
    public minor: number;
    public patch: number;

    constructor(version: string);
    constructor(major: number, minor: number, patch: number);

    constructor(a: string | number, b?: number, c?: number) {
        if (typeof a === 'string') {
            const splitted = a.split('.');
            this.major = splitted.length > 0 ? parseInt(splitted[0], 10) : 0;
            this.minor = splitted.length > 1 ? parseInt(splitted[1], 10) : 0;
            this.patch = splitted.length > 2 ? parseInt(splitted[2], 10) : 0;
        } else if (typeof a === 'number' && typeof b === 'number' && typeof c === 'number') {
            this.major = a;
            this.minor = b;
            this.patch = c;
        } else {
            throw new Error('Invalid constructor arguments');
        }
    }

    /**
     * Compares this version with another {@link Versioning} instance.
     *
     * @param other The other version to compare with.
     * @returns `1` if this version is greater than `other`,
     *          `-1` if this version is less than `other`,
     *          or `0` if both versions are equal.
     */
    compareTo(other: Versioning): number {
        if (this.major > other.major) return 1;
        if (this.major < other.major) return -1;

        if (this.minor > other.minor) return 1;
        if (this.minor < other.minor) return -1;

        if (this.patch > other.patch) return 1;
        if (this.patch < other.patch) return -1;

        return 0;
    }
}
